module.exports = __webpack_public_path__ + "img/Group8640_2x.06c0b9de.png";